import type { Locale } from "./index.js";

const dictionary = {
  de: {
    brandTagline: "Live. Direkt. Gemeinsam.",
    upcoming: "Demnächst",
    live: "Live",
    paused: "Kurze Pause",
    hidden: "Versteckt",
    archived: "Archiv",
    removed: "Entfernt",
    countdown: "Start in",
    days: "Tage",
    hours: "Std.",
    minutes: "Min.",
    seconds: "Sek.",
    timeline: "Live-Ticker",
    pinned: "Angeheftet",
    liveVideo: "Live-Video",
    latest: "Neueste zuerst",
    oldest: "Älteste zuerst",
    share: "Teilen",
    copyLink: "Link kopieren",
    copied: "Kopiert",
    externalMedia: "Externer Inhalt",
    externalMediaDescription:
      "Beim Anzeigen können Daten an {provider} übertragen werden.",
    videoProcessing: "Video wird noch verarbeitet…",
    videoFailed: "Dieses Video konnte nicht verarbeitet werden.",
    allowOnce: "Einmal anzeigen",
    allowAll: "Immer erlauben",
    openFallback: "Beim Anbieter öffnen",
    playAudio: "Audio starten",
    stopAudio: "Audio pausieren",
    online: "gerade online",
    submissionTitle: "Dein Moment",
    submissionDescription: "Schick uns eine Beobachtung für den Live-Ticker.",
    submissionName: "Dein Name",
    submissionMessage: "Was passiert gerade?",
    submissionConsent:
      "Ich stimme der Verarbeitung zur redaktionellen Prüfung zu.",
    submit: "Zur Prüfung senden",
    submitted: "Danke – dein Beitrag wartet auf Freigabe.",
    noPosts: "Hier erscheint der Live-Ticker, sobald es losgeht.",
    productBy: "Ein Live-Erlebnis von",
    allEvents: "Alle Events",
    admin: "Redaktion",
    signIn: "Anmelden",
    email: "E-Mail",
    password: "Passwort",
    forgotPassword: "Passwort vergessen?",
    dashboard: "Lagezentrum",
    compose: "Beitrag",
    approvals: "Freigaben",
    statistics: "Statistik",
    settings: "Einstellungen",
    publish: "Jetzt senden",
    schedule: "Planen",
    draft: "Entwurf sichern",
    offline: "Offline – Beiträge werden sicher vorgemerkt",
    chatTitle: "Live-Chat",
    chatPausedTitle: "Chat pausiert",
    chatPausedDescription: "Die Redaktion hat den Chat momentan angehalten.",
    chatPlaceholder: "Nachricht schreiben…",
    chatSend: "Senden",
    chatNameLabel: "Dein Name im Chat",
    chatAsName: "Du schreibst als {name}",
    chatNameChange: "ändern",
    chatNameError: "Bitte gib einen Namen an.",
    chatCaptchaLabel: "Kurz bestätigen, dass du kein Bot bist",
    chatCaptchaPending: "Bestätige oben, dass du kein Bot bist.",
    chatCaptchaFailed:
      "Die Prüfung ist fehlgeschlagen ({code}). Bitte versuche es erneut.",
    chatCaptchaRetry: "Prüfung neu starten",
    chatEmpty: "Noch keine Nachrichten. Sei der erste Beitrag!",
    chatJoin: "Am Chat teilnehmen",
    chatMuted: "Du bist vorläufig gesperrt",
    chatBanned: "Du bist vom Chat ausgeschlossen",
    chatRejected: "Diese Nachricht kann nicht veröffentlicht werden.",
    chatError: "Der Chat konnte gerade nicht erreicht werden.",
    chatReadonlyArchived: "Das Event ist beendet – der Chat ist nur lesbar.",
    chatSlowMode: "Slow-Modus: warte {seconds} s",
    setlistAll: "Alle Songs",
    chatEditorBadge: "Redaktion",
    chatMaximize: "Chat maximieren",
    chatShrink: "Chat verkleinern",
    chatReply: "Antworten",
    chatReplyTo: "Antwort an {name}",
    chatReplyCancel: "Antwort verwerfen",
  },
  en: {
    brandTagline: "Live. Direct. Together.",
    upcoming: "Coming up",
    live: "Live",
    paused: "Short break",
    hidden: "Hidden",
    archived: "Archive",
    removed: "Removed",
    countdown: "Starts in",
    days: "Days",
    hours: "Hrs",
    minutes: "Min",
    seconds: "Sec",
    timeline: "Live feed",
    pinned: "Pinned",
    liveVideo: "Live video",
    latest: "Newest first",
    oldest: "Oldest first",
    share: "Share",
    copyLink: "Copy link",
    copied: "Copied",
    externalMedia: "External content",
    externalMediaDescription: "Viewing this may transfer data to {provider}.",
    videoProcessing: "Video is still being processed…",
    videoFailed: "This video could not be processed.",
    allowOnce: "Show once",
    allowAll: "Always allow",
    openFallback: "Open with provider",
    playAudio: "Play audio",
    stopAudio: "Pause audio",
    online: "online now",
    submissionTitle: "Your moment",
    submissionDescription: "Send us an observation for the live feed.",
    submissionName: "Your name",
    submissionMessage: "What is happening?",
    submissionConsent: "I consent to editorial review of this submission.",
    submit: "Send for review",
    submitted: "Thank you – your post is awaiting approval.",
    noPosts: "The live feed will appear here when the event begins.",
    productBy: "A live experience by",
    allEvents: "All events",
    admin: "Newsroom",
    signIn: "Sign in",
    email: "Email",
    password: "Password",
    forgotPassword: "Forgot password?",
    dashboard: "Live desk",
    compose: "Compose",
    approvals: "Approvals",
    statistics: "Statistics",
    settings: "Settings",
    publish: "Send now",
    schedule: "Schedule",
    draft: "Save draft",
    offline: "Offline – posts are queued safely",
    chatTitle: "Live chat",
    chatPausedTitle: "Chat paused",
    chatPausedDescription: "The editors temporarily paused this chat.",
    chatPlaceholder: "Write a message…",
    chatSend: "Send",
    chatNameLabel: "Your chat name",
    chatAsName: "You are posting as {name}",
    chatNameChange: "change",
    chatNameError: "Please enter a name.",
    chatCaptchaLabel: "A quick check so we know you are not a bot",
    chatCaptchaPending: "First confirm above that you are not a bot.",
    chatCaptchaFailed: "The check failed ({code}). Please try again.",
    chatCaptchaRetry: "Retry the check",
    chatEmpty: "No messages yet. Be the first!",
    chatJoin: "Join the chat",
    chatMuted: "You are temporarily timed out",
    chatBanned: "You are banned from this chat",
    chatRejected: "This message cannot be published.",
    chatError: "The chat could not be reached just now.",
    chatReadonlyArchived: "This event has ended – the chat is read-only.",
    chatSlowMode: "Slow mode: wait {seconds}",
    setlistAll: "All songs",
    chatEditorBadge: "Editor",
    chatMaximize: "Maximize chat",
    chatShrink: "Shrink chat",
    chatReply: "Reply",
    chatReplyTo: "Reply to {name}",
    chatReplyCancel: "Cancel reply",
  },
} as const;
export type TranslationKey = keyof (typeof dictionary)["de"];

export const t = (locale: Locale, key: TranslationKey): string =>
  dictionary[locale]?.[key] ?? dictionary.de[key];
